const locale = {
	TITLE: 'Load Search'
};

export default locale;
